import { render, staticRenderFns } from "./ReferralTimeSlotsPreview.vue?vue&type=template&id=28f6d616&scoped=true"
import script from "./ReferralTimeSlotsPreview.vue?vue&type=script&lang=js"
export * from "./ReferralTimeSlotsPreview.vue?vue&type=script&lang=js"
import style0 from "./ReferralTimeSlotsPreview.vue?vue&type=style&index=0&id=28f6d616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f6d616",
  null
  
)

export default component.exports